<template>
  <span class="field-skeleton" />
</template>

<script>
export default {
  name: 'FieldSkeleton',
}
</script>

<style lang="scss" scoped>
.field-skeleton {
  display: inline-block;
  height: 1.4em; // fallback for browsers without lh unit support
  height: 1lh;
  min-width: 6em;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.06);
  opacity: 0.6;
  position: relative;
  overflow: hidden;
  vertical-align: middle;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 300%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent 0%,
      transparent 33%,
      rgba(255, 255, 255, 0.8) 50%,
      transparent 67%,
      transparent 100%
    );
    animation: field-skeleton-shimmer 1.4s ease-in-out infinite;
  }
}

@keyframes field-skeleton-shimmer {
  0% {
    transform: translateX(-33%);
  }
  100% {
    transform: translateX(33%);
  }
}
</style>
